import { render, staticRenderFns } from "./RegisterTenantView.vue?vue&type=template&id=336fea14&scoped=true"
import script from "./RegisterTenantView.vue?vue&type=script&lang=js"
export * from "./RegisterTenantView.vue?vue&type=script&lang=js"
import style0 from "./RegisterTenantView.vue?vue&type=style&index=0&id=336fea14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fea14",
  null
  
)

export default component.exports